import React from 'react';
import { usePrevious } from 'hooks';

export default function useFileToLocalUrl(file?: File): string | undefined {
  const [fileUrl, setSelectedFileUrl] = React.useState<string | undefined>();

  const previousSelectedFileUrl = usePrevious(fileUrl);

  React.useEffect(() => {
    if (file) {
      if (file.url) {
        setSelectedFileUrl(file.url);
      } else {
        setSelectedFileUrl(URL.createObjectURL(file));
      }
    }
  }, [file]);

  React.useEffect(() => {
    revokeObjectUrlIfExists(previousSelectedFileUrl);

    return () => revokeObjectUrlIfExists(fileUrl);
  }, [fileUrl]);

  function revokeObjectUrlIfExists(url) {
    if (url) {
      URL.revokeObjectURL(url);
    }
  }

  return file ? fileUrl : undefined;
}
